<template>
  <div>
    <!-- NIVELES DE UBICACIÓN -->
    <temporaryLocations />

    <!-- ARBOL DE UBICACIONES -->
    <tree></tree>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import tree from "./ubicaciones-empresa";
import temporaryLocations from "./temporaryLocations";

export default {
  name: "index",
  async mounted() {
    await this.listLevels();
    await this.listarUbicaciones()
    await this.arbolUbicacionesEmpresa({ all: 1 });
    await this.getTemporaryLocations();
  },
  components: {
    tree,
    temporaryLocations
  },
  methods: {
    ...mapActions("location", [
      "listLevels",
      "listarUbicaciones",
      "arbolUbicacionesEmpresa",
      "getTemporaryLocations"
    ]),
  },
};
</script>

